import { initAll, setGroup, setUserId, track } from '@amplitude/unified'
import { Environment, getEnvironment } from '@backoffice-frontend/environment'
import { useEffect } from 'react'

const AMPLITUDE_API_KEY = 'c7550f5d69449204fd58db0469a8cb75'

let initialized = false

export const initAnalytics = () => {
  if (initialized) return
  initialized = true

  if (getEnvironment() !== Environment.production) return
  if (window.location.hostname === 'localhost') return

  initAll(AMPLITUDE_API_KEY, {
    serverZone: 'EU',
    analytics: {
      autocapture: {
        elementInteractions: false,
        formInteractions: false,
        fileDownloads: false,
      },
    },
  })
}

export const identifyAnalyticsUser = (userId: string, organization: string) => {
  setUserId(userId)
  setGroup('organization', organization)
}

type TrackingProps = {
  action?: string
  category?: string
  label?: string
  value?: number
}

export const trackAnalyticsEvent = (props: TrackingProps) => {
  track(props.action ?? 'event', props)
}

export const trackClickEvent = (label: string) => {
  track('click', { label })
}

export const useImpressionTracking = (props: Omit<TrackingProps, 'action'>) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: fire once on mount
  useEffect(() => {
    track('impression', props)
  }, [])
}
